import React, { memo } from "react";
import { Divider, Stack } from "@mui/material";
import { APP_ELEMENT_DIMENSIONS } from "../../constants";
import ScoringWeekNav from "./ScoringWeekNav";
import ScoringCommentFilterSwitch from "./ScoringCommentFilterSwitch";
import ScoringPresentationLink from "./ScoringPresentationLink";
import { useTheme } from '@mui/material/styles';

const ScoringNavBar = () => {
    const theme = useTheme();
    return (
        <Stack
            direction="row"
            sx={{
                minHeight: APP_ELEMENT_DIMENSIONS.CANVAS_TOOLBAR.HEIGHT,
                backgroundColor: theme?.custom?.scoringToolbarBg,
                width: "100%",
                borderBottom: `1px solid ${theme?.custom?.borderGrey}`,
                alignItems: "center",
                padding: "8px 16px",
                flexWrap: "wrap",
            }}
            spacing={2}
        >
            <ScoringWeekNav />
            <Divider
                flexItem={true}
                orientation="vertical"
            />
            <ScoringCommentFilterSwitch />
            <ScoringPresentationLink sx={{ marginLeft: "auto !important" }} />
        </Stack>
    );
};

export default memo(ScoringNavBar);
